import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { RouteComponentProps } from 'react-router-dom';
import { PageList } from '~/layout';
import { Terminal } from '~/types';
import PaymentDetailsCreate from './PaymentDetailsCreate';
import Filters from './Filters';
import PaymentDetailsShow from './PaymentDetailsShow';
import PaymentDetailsTable from './PaymentDetailsTable';
import PaymentDetailsCards from './PaymentDetailsCards';
import TerminalShow from '../terminals/components/TerminalShow';
import { usePermissions } from '~/hooks';
import { NoPermission } from '~/components';
import { usePaymentDetailsQuery } from '~/hooks/paymentDetails';
import { useAllTerminals } from '~/hooks/terminals';
import { detachKeys } from '~/utils';
import { useKycCheck } from '~/hooks/kyc';
import KycContent from '../kyc/KycContent';

const PaymentDetailsPage: FC<RouteComponentProps> = () => {
  const { t } = useTranslation('paymentDetails');
  const { data, isLoading, isFetching, total } = usePaymentDetailsQuery();

  const { data: allTerminals } = useAllTerminals();
  const [terminalsById] = detachKeys<Terminal>(allTerminals);

  const kycCheck = useKycCheck();

  const hasAccess = usePermissions('business.paymentDetails.list');
  if (!hasAccess) return <NoPermission />;
  if (!kycCheck.isCompleted) return <KycContent {...kycCheck} />;
  return (
    <>
      <TerminalShow />
      <PaymentDetailsShow terminalsById={terminalsById} />
      <PageList
        header={{
          heading: t('paymentDetails'),
          searchPlaceholder: t('searchPlaceholder'),
          showSearch: false,
          isFetching,
        }}
        filters={<Filters />}
        table={
          <PaymentDetailsTable
            data={data}
            loading={isLoading}
            total={total}
            terminalsById={terminalsById}
          />
        }
        cards={
          <PaymentDetailsCards
            data={data}
            loading={isLoading}
            total={total}
            terminalsById={terminalsById}
          />
        }
        add={<PaymentDetailsCreate />}
        defaultDisplayMode="cards"
      />
    </>
  );
};

export default PaymentDetailsPage;
